var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPopupQuestionNewVersion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2436_8475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4763 13.6559V35.2178L40.6095 54.0849H25.5701L15.5436 64.0572C14.7891 64.8659 13.603 65.0814 12.6328 64.6501C11.6086 64.2191 10.9617 63.2489 10.9617 62.1706V53.8153C4.8166 52.5753 0.000976562 47.1308 0.000976562 40.6087V13.6559C0.00115625 6.21701 6.21816 0 13.657 0H46.0001C53.439 0 59.4763 6.21701 59.4763 13.6559Z",
    fill: "url(#paint0_linear_2436_8475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5234 40.6084C32.5234 42.1176 31.3377 43.3037 29.8281 43.3037C28.3186 43.3037 27.1328 42.1176 27.1328 40.6084C27.1328 39.0988 28.3186 37.9131 29.8281 37.9131C31.3377 37.9131 32.5234 39.0988 32.5234 40.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9141 19.0469C37.9141 21.5803 36.7283 24.0059 34.6799 25.5154C33.3322 26.5397 32.5234 28.1569 32.5234 29.8278C32.5234 31.337 31.3377 32.5231 29.8281 32.5231C28.3186 32.5231 27.1328 31.337 27.1328 29.8278C27.1328 27.1864 28.1031 24.6528 29.8281 22.7123C30.3135 22.1731 30.8523 21.6342 31.4453 21.2028C32.1461 20.6639 32.5234 19.909 32.5234 19.0467C32.5234 17.5371 31.3377 16.3514 29.8281 16.3514C28.3186 16.3514 27.1328 17.5371 27.1328 19.0467C27.1328 20.5559 25.9471 21.742 24.4375 21.742C22.9279 21.742 21.7422 20.5559 21.7422 19.0467C21.7422 14.5725 25.3537 10.9609 29.8279 10.9609C34.3022 10.9609 37.9141 14.5725 37.9141 19.0469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3428 32.5225H51.3903C43.9514 32.5225 37.9141 38.5598 37.9141 45.9987V67.5606C37.9141 74.9995 43.9514 81.0368 51.3903 81.0368H54.0856V89.3023C54.0856 90.3804 54.7325 91.3507 55.7567 91.7818C56.727 92.2132 57.9131 91.9976 58.6674 91.1888L64.8666 84.864L68.6942 81.0368H78.343C85.7819 81.0368 91.9989 74.9995 91.9989 67.5606V45.9988C91.9987 38.5598 85.7817 32.5225 78.3428 32.5225Z",
    fill: "url(#paint1_linear_2436_8475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2297 53.2762L64.8668 68.6393L64.0581 69.4477C63.5731 69.987 62.8723 70.2565 62.1715 70.2565C61.4707 70.2565 60.77 69.987 60.285 69.4477L54.8945 64.0573C53.8164 63.0331 53.8164 61.3081 54.8945 60.2839C55.9187 59.2059 57.6434 59.2059 58.6678 60.2839L62.1719 63.7339L64.8672 61.0385L76.457 49.5028C77.4813 48.4248 79.2059 48.4248 80.2303 49.5028C81.3079 50.527 81.3079 52.252 80.2297 53.2762Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2436_8475",
    x1: 29.7386,
    y1: 0,
    x2: 29.7386,
    y2: 64.8678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2436_8475",
    x1: 64.9565,
    y1: 32.5225,
    x2: 64.9565,
    y2: 91.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DA8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93EDCA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2436_8475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopupQuestionNewVersion);
export default __webpack_public_path__ + "static/media/icon_popup_question_new_version.dafaf4f9400d47b694ad798c2ab77bbd.svg";
export { ForwardRef as ReactComponent };